import { MutationTree } from 'vuex';
import { ProductState } from '@/store/types';
import { Product } from '@/models/product';

const mutations: MutationTree<ProductState> = {
  setProducts: (state: ProductState, products: Product[]): void => {
    state.products = products;
  },
  setSearch: (state: ProductState, search: string): void => {
    state.search = search;
  },
  clearSearch: (state: ProductState): void => {
    state.search = '';
  },
};

export default mutations;
